import { ReactNode } from 'react';
import { PageTitleProvider, AccountTypeProvider } from './contexts';

interface AppContextProviderProps {
    children: ReactNode;
}

export const AppContextProvider = ({ children }: AppContextProviderProps) => {
    return (
        <PageTitleProvider>
            <AccountTypeProvider>{children}</AccountTypeProvider>
        </PageTitleProvider>
    );
};
